import { Component, inject } from "@angular/core";
import { NgGlyph } from "@ng-icons/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { SidebarMenuItem } from "./Type/SidebarType";
import { StorageEffects } from "../../Storage/State/StorageEffects";
import { StorageKeys } from "../../Storage/Dto/StorageKeys";

@Component({
  selector: "app-sidebar",
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgGlyph],
  templateUrl: "./SidebarComponent.html",
  styleUrl: "./SidebarComponent.scss",
})
export class SidebarComponent {
  private readonly storageEffects = inject(StorageEffects);

  readonly menuItems: SidebarMenuItem[] = [
    {
      label: "Home",
      icon: "home",
      route: "/home",
    },
    {
      label: "Relation Manager",
      icon: "group",
      children: [
        {
          label: "Partners",
          icon: "business",
          route: "/partners",
        },
        {
          label: "Team Leaders",
          icon: "people",
          route: "/team-leaders",
        },
        {
          label: "Testimonies",
          icon: "rate_review",
          route: "/testimonies",
        },
      ],
    },
    {
      label: "Inventory",
      icon: "inventory",
      children: [
        {
          label: "Vendors",
          icon: "storefront",
          route: "/vendors",
        },
        {
          label: "Printings",
          icon: "stacks",
          route: "/printings",
        },
        {
          label: "Ware Houses",
          icon: "package_2",
          route: "/warehouses",
        },
        {
          label: "Materials",
          icon: "menu_book",
          route: "/materials",
        },
        {
          label: "Stocks",
          icon: "list",
          route: "/stocks",
        },
        {
          label: "Requests",
          icon: "note_stack",
          route: "/requests",
        },
        {
          label: "Shipments",
          icon: "local_shipping",
          route: "/shipments",
        },
      ],
    },
    {
      label: "System",
      icon: "admin_panel_settings",
      children: [
        {
          label: "Users",
          icon: "group",
          route: "/users",
        },
        {
          label: "Roles",
          icon: "lock",
          route: "/roles",
        },
        {
          label: "Sessions",
          icon: "devices",
          route: "/sessions",
        },
        {
          label: "Audits",
          icon: "article",
          route: "/audits",
        },
        {
          label: "Files",
          icon: "folder",
          route: "/files",
        },
      ],
    },
  ];

  private expandedMenus: Set<string> = new Set<string>();

  constructor() {
    this.loadExpandedMenus();
  }

  private loadExpandedMenus(): void {
    const stored = this.storageEffects.getJsonItem<string[]>(StorageKeys.SidebarExpandedMenus);
    if (stored) {
      this.expandedMenus = new Set(stored);
    }
  }

  private saveExpandedMenus(): void {
    this.storageEffects.setJsonItem(StorageKeys.SidebarExpandedMenus, Array.from(this.expandedMenus));
  }

  toggleMenu(menuLabel: string): void {
    if (this.isMenuExpanded(menuLabel)) {
      this.expandedMenus.delete(menuLabel);
    } else {
      this.expandedMenus.add(menuLabel);
    }
    this.saveExpandedMenus();
  }

  isMenuExpanded(menuLabel: string): boolean {
    return this.expandedMenus.has(menuLabel);
  }
}
